import { requiredTimeMessage } from "../validationMessages";
import { timeValidator as timeValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

export const timeValidatorRequired = trimmedString
  .required(requiredTimeMessage)
  .matches(timeValidatorRegex, requiredTimeMessage);
